import React from 'react';
import data from './data.json';
import SampleEntryBaseTable from '../BaseTable';
import { IPrintGMDSSTableData } from 'redux/app/vessel/inspector/types';

function SampleLogEntryTable4() {
    const tableData: IPrintGMDSSTableData = data;
    return (
        <div className="w-full overflow-x-auto p-4 bg-white flex flex-col justify-between py-4 mb-2 print-page-break">
            <SampleEntryBaseTable tableData={tableData} />
        </div>
    );
}

export default SampleLogEntryTable4;